import { stringify } from 'query-string';

import { SendMailButton } from "./SendMailButton";
import { ToolbarLinkButton } from "./ToolbarButton";
import { Stack } from '@mui/material';
import { CloneButton, PrevNextButtons, TopToolbar, useRecordContext } from 'react-admin';
import { OpenProfileButton } from './OpenProfileButton';
import MessageOutlinedIcon from '@mui/icons-material/MessageOutlined';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';
import EventRepeatOutlinedIcon from '@mui/icons-material/EventRepeatOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import Diversity1OutlinedIcon from '@mui/icons-material/Diversity1Outlined';
import { UserCloneButton } from './UserCloneButton';

export const UserEditButtonsToolbar = (props: any) => {
    const variant = "text"
    const makeTo = (pathname: string, filterValue: any) => ({
        pathname: pathname,
        search: stringify({
            filter: JSON.stringify(filterValue)
        })
    });

    const record = useRecordContext(props);

    return (
        <TopToolbar
            sx={{
                flexWrap: "wrap",
                justifyContent: "flex-start",
                mb:1,
                gap:"4px"
            }}
            
        >
            {record && <>
                <PrevNextButtons limit={10} />
                <OpenProfileButton variant={variant} />
                <UserCloneButton variant={variant} />
                <Stack direction="row" gap={[0,1]}>
                    <SendMailButton variant={variant} />
                    <ToolbarLinkButton label='Chats' to={makeTo('/conversation', { "users": record?.id, withDeleted:true })} variant={variant}>
                        <MessageOutlinedIcon />
                    </ToolbarLinkButton>
                    <ToolbarLinkButton label='Messages' to={makeTo('/message', { "sender|to": record?.id })} variant={variant}>
                        <MessageOutlinedIcon />
                    </ToolbarLinkButton>
                </Stack>
                <Stack direction="row" gap={[0,1]}>
                    <ToolbarLinkButton label='Credits Log' to={makeTo('/CreditsLog', { "user": record?.id })} color='secondary' variant={variant}>
                        <CreditCardOutlinedIcon />
                    </ToolbarLinkButton>
                    <ToolbarLinkButton label='Claimed Days' to={makeTo('/ClaimedDay', { "user": record?.id })} color='secondary' variant={variant}>
                        <EventRepeatOutlinedIcon />
                    </ToolbarLinkButton>
                    <ToolbarLinkButton label='Transactions' to={makeTo('/transaction', { "user": record?.id })} color='secondary' variant={variant}>
                        <AccountBalanceOutlinedIcon />
                    </ToolbarLinkButton>
                </Stack>
                <Stack direction="row" gap={[0,1]}>
                    <ToolbarLinkButton label='Report From' to={makeTo('/report', { "reporter": record?.id })} color='error' variant={variant}>
                        <ListAltOutlinedIcon />
                    </ToolbarLinkButton>
                    <ToolbarLinkButton label='Report About' to={makeTo('/report', { "about": record?.id })} color='error' variant={variant} >
                        <ListAltOutlinedIcon />
                    </ToolbarLinkButton>
                </Stack>
                <Stack direction="row" gap={[0,1]}>
                    <ToolbarLinkButton label='I Liked' to={makeTo('/userlike', { "actor": record?.id })} color='success' variant={variant} >
                        <FavoriteBorderOutlinedIcon />
                    </ToolbarLinkButton>
                    <ToolbarLinkButton label='Liked Me' to={makeTo('/userlike', { "subject": record?.id })} color='success' variant={variant}>

                        <FavoriteBorderOutlinedIcon />
                    </ToolbarLinkButton>
                    <ToolbarLinkButton label='Matches' to={makeTo('/userlikematch', { "users": record?.id })} color='success' variant={variant}>
                        <Diversity1OutlinedIcon />
                    </ToolbarLinkButton>
                </Stack>
            </>}
        </TopToolbar>
    )
}

